<template>
  <Modal :visible="visible" @hide="onCancel" :back-drop="false">
    <div class="v-layout content" style="position: relative" >
      <div class="header">
        <label class="lbl_default3">공지사항</label>
      </div>
      <div class="body  v-layout align-items-center" style="background:white;" @click="goTo">
        <label class="lbl_default7_2 lbl_bold mb-1" style="color: #353A3F">{{ data.title }}</label>
        <img :src="data.image.url" style="width: 100%" />
      </div>
      <div class="footer h-layout justify-center">
        <check-box
            v-model="is_hide_today"
            @onChange="onChangeShowPopupYN"
            font-style="font-size: 14px;"
            :label="$t('mission.hide_notice_popup_today')" />
      </div>
    </div>
  </Modal>

</template>

<script>
import Modal from "@/components/Modal";
import CheckBox from "../CheckBox";
import * as ajax from "../../utils/ajax";
import {parseFile} from "../../utils/utils";
import u from "util";
import * as biz from "../../utils/biz";
import * as utils from "../../utils/utils"

export default {
  name: "NoticePopup",
  components: {Modal, CheckBox},
  data() {
    return {
      data:{
        image:{},
      },
      visible:false,
      visible_temp:false,
      is_hide_today:false,
      isLogin:false,
    }
  },
  methods: {
    onCancel(){
      this.visible = false;
    },
    goTo(){
      // location.href = url;
      switch(utils.deviceInfo()) {
        case "Android":
          window.listenApp.invokeBrowser(this.data.link_url);
          break;
        case "iOS":
          window.webkit.messageHandlers.invokeBrowser.postMessage(this.data.link_url);
          break;
      }
      // this.$router.push(url);
    },
    onChangeShowPopupYN(state) {
      ajax.Post(this, "/api/mainpg/changeShowPopup_yn", {isNotShow: state ? 'Y' :'N', type:'notice'}, function(ref, data) {
        // ref.$store.state.doNotShowNoticePopupToday = state;
        ref.is_hide_today = state;
      })
    },

  },
  mounted(){
    this.isLogin = biz.isLogin(this);

    ajax.Get(this, "/api/admin/popup/", function(ref, data) {
      ref.data = data;
      ref.data.image = parseFile(data.image);
      ref.visible_temp = data.state === 'Y';
      if(ref.isLogin){
        ajax.Get(ref, "/api/mainpg/changeShowPopup_yn", function(ref, data) {
          ref.is_hide_today = (data.doNotShowPopup_yn_notice === 'Y' &&
              new Date(data.showNextTime_notice) > new Date(data.now));
          ref.visible = ref.visible_temp && !ref.is_hide_today;
        });
      }

    });
  }
}
</script>

<style scoped lang="scss">
.header {
  background-color: $primary_color;
  color: white;
  border-radius: 10px 10px 0 0;
  padding: 15px 0;
  text-align: center;
}
.body {
  background-color: #323232;
  padding: 20px 10px;
}
.content {
  background-color: white;
  border-radius: 10px;
}
.footer {
  border-top: solid 2px $light-grey_1;
  padding: 20px 0;
}
</style>